import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
const INITIAL_STATE = {
    customerIdentifier: null,
    customerAWSAccountID: null,
    productCode: null,
    sub: null,
    email: null,
    role: null,
    tokenExpiry: null
};
// Note: parseCookies function removed since HttpOnly cookies aren't accessible
// Note: HttpOnly cookies are not accessible via document.cookie in JavaScript
// This is by design for security - they can only be read by the server
// Authentication data will be retrieved via API calls in the future
const useAuthStoreBase = create()(persist((set, get)=>({
        tokenData: INITIAL_STATE,
        actions: {
            clearTokenData: ()=>{
                set({
                    tokenData: INITIAL_STATE
                });
            },
            setSessionData: (data)=>{
                set({
                    tokenData: {
                        ...INITIAL_STATE,
                        ...data
                    }
                });
            },
            isTokenValid: ()=>{
                const { tokenData } = get();
                if (!tokenData?.tokenExpiry) return false;
                const now = Math.floor(Date.now() / 1000);
                const isValid = now < tokenData.tokenExpiry;
                return isValid;
            }
        }
    }), {
    name: "auth-token-storage",
    partialize: (state)=>({
            tokenData: state.tokenData
        }),
    storage: createJSONStorage(()=>localStorage)
}));
// Debug function - can be called from browser console
if (typeof window !== "undefined" && import.meta.env.MODE === "development") {
    window.debugAuthStore = ()=>{
        localStorage.removeItem("auth-token-storage");
        window.location.reload();
    };
}
export default function useAuthStore() {
    const tokenData = useAuthStoreBase((state)=>state.tokenData);
    const actions = useAuthStoreBase((state)=>state.actions);
    return {
        tokenData,
        customerIdentifier: tokenData?.customerIdentifier || null,
        customerAWSAccountID: tokenData?.customerAWSAccountID || null,
        productCode: tokenData?.productCode || null,
        userSub: tokenData?.sub || null,
        userEmail: tokenData?.email || null,
        userRole: tokenData?.role || null,
        clearTokenData: actions.clearTokenData,
        isTokenValid: actions.isTokenValid,
        setSessionData: actions.setSessionData
    };
}
